import { ReactNode } from "react";
import styles from "./layout.module.scss";
import AppHeader from "./app-header";
import AppBreadcrumb from "../app-breadcrumb";
import Footer from "./footer";

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className={styles.layout_container}>
      <AppHeader />
      <AppBreadcrumb />

      <main>{children}</main>
      <Footer />
    </div>
  );
}
